/* ESSENTIRA — Ver más / Ver menos */
(function () {
  'use strict';
  function arr(l) { return Array.prototype.slice.call(l); }
  function limitOf(el) { return parseInt(el.getAttribute('data-collapse-max'), 10) || 240; }

  /* Mide con el bloque ya visible: dentro de una pestaña oculta scrollHeight es 0. */
  function setup(el) {
    var body = el.querySelector('[data-collapse-body]');
    var btn = el.querySelector('[data-collapse-toggle]');
    if (!body || !btn) return;
    if (el.offsetParent === null) return;

    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var limit = limitOf(el);

    el.classList.remove('is-collapsed');
    body.style.maxHeight = 'none';
    var full = body.scrollHeight;

    if (full <= limit + 40) {
      btn.hidden = true;
      body.style.maxHeight = '';
      return;
    }
    btn.hidden = false;

    if (expanded) {
      body.style.maxHeight = 'none';
      btn.textContent = 'Ver menos';
    } else {
      el.classList.add('is-collapsed');
      body.style.maxHeight = limit + 'px';
      btn.textContent = 'Ver más';
    }
  }

  function boot(scope) { arr((scope || document).querySelectorAll('[data-collapse]')).forEach(setup); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Al cambiar de pestaña el bloque recién visible hay que medirlo. */
    if (t.closest('[data-tabs] .tab')) { window.setTimeout(function () { boot(); }, 0); return; }

    var btn = t.closest('[data-collapse-toggle]');
    if (!btn) return;
    e.preventDefault();

    var el = btn.closest('[data-collapse]');
    var body = el.querySelector('[data-collapse-body]');
    if (!body) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      body.style.maxHeight = body.scrollHeight + 'px';
      window.requestAnimationFrame(function () {
        el.classList.add('is-collapsed');
        body.style.maxHeight = limitOf(el) + 'px';
      });
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Ver más';
      var top = el.getBoundingClientRect().top + window.pageYOffset - 100;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      el.classList.remove('is-collapsed');
      body.style.maxHeight = body.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = 'Ver menos';
      window.setTimeout(function () {
        if (btn.getAttribute('aria-expanded') === 'true') body.style.maxHeight = 'none';
      }, 360);
    }
  });

  var t = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(t);
    t = window.setTimeout(function () { boot(); }, 180);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
